import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { Avatar } from 'bookraw/shared/models/avatar.model';

@Injectable()
export class AvatarsService extends ListService<Avatar> {

  url: string = '/api/admin/avatars';
}
